'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _review = require('./review');

var _review2 = _interopRequireDefault(_review);

var _scoresheet = require('./scoresheet');

var _scoresheet2 = _interopRequireDefault(_scoresheet);

var _events = require('../../../../../events');

var _events2 = _interopRequireDefault(_events);

var _adjudicators = require('../../../../../adjudicators');

var _adjudicators2 = _interopRequireDefault(_adjudicators);

var _eventPipeline = require('./eventPipeline');

var _eventPipeline2 = _interopRequireDefault(_eventPipeline);

var _events3 = require('ifeis-isomorphic/lib/utilities/events');

var _adjudicators3 = require('ifeis-isomorphic/lib/redux/actions/adjudicators');

var _events4 = require('ifeis-isomorphic/lib/redux/actions/events');

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _ifeisIsomorphic = require('ifeis-isomorphic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TabulationsController = function () {
  function TabulationsController($ngRedux, $q, $scope, fEventPipelineService, feis, $state, $mdDialog, msgService, $timeout, fAlert) {
    var _this = this;

    _classCallCheck(this, TabulationsController);

    this._svc = {
      $ngRedux: $ngRedux,
      $q: $q,
      $scope: $scope,
      fEventPipelineService: fEventPipelineService,
      $state: $state,
      $mdDialog: $mdDialog,
      msgService: msgService,
      fAlert: fAlert
    };

    this.eventPipeline = fEventPipelineService(feis.id);
    this.isLoading = true;
    this.feis = feis;
    var refreshPromise = void 0;

    var getInitialData = function getInitialData() {
      var rdx = _this._svc.$ngRedux;

      var adjPromise = rdx.dispatch((0, _adjudicators3.getFeisAdjudicators)(feis.id));
      var eventsPromise = $q.all([rdx.dispatch((0, _events4.getEventsWithStatus)(feis.id, 'ADJ')), rdx.dispatch((0, _events4.getEventsWithStatus)(feis.id, 'QA')), rdx.dispatch((0, _events4.getEventsWithStatus)(feis.id, 'TABS'))]).then(function (e) {
        return $q.all(e.flat().forEach(function (ev) {
          return rdx.dispatch((0, _events4.getAdjudicatorsForEvent)(_this.feis.id, ev.id));
        }));
      });

      return $q.all([adjPromise, eventsPromise]);
    };

    var refresh = function refresh() {
      return getInitialData().finally(function () {
        return refreshPromise = $timeout(refresh, 30000);
      });
    };

    this._svc.$ngRedux.dispatch((0, _adjudicators3.getFeisAdjudicators)(feis.id));
    this._svc.$ngRedux.dispatch((0, _events4.getEventsWithStatus)(feis.id, 'ADJ')).then(function (resp) {
      resp.payload.forEach(function (event) {
        return _this._svc.$ngRedux.dispatch((0, _events4.getAdjudicatorsForEvent)(_this.feis.id, event.id));
      });
    });
    this._svc.$ngRedux.dispatch((0, _events4.getEventsWithStatus)(feis.id, 'QA')).then(function (resp) {
      resp.payload.forEach(function (event) {
        return _this._svc.$ngRedux.dispatch((0, _events4.getAdjudicatorsForEvent)(_this.feis.id, event.id));
      });
    });
    this._svc.$ngRedux.dispatch((0, _events4.getEventsWithStatus)(feis.id, 'TABS')).then(function (resp) {
      resp.payload.forEach(function (event) {
        return _this._svc.$ngRedux.dispatch((0, _events4.getAdjudicatorsForEvent)(_this.feis.id, event.id));
      });
    });

    var mapTabulations = (0, _mapStateToController2.default)(feis.id);

    this._svc.$ngRedux.connect(function (state) {
      var tabulations = mapTabulations(state);

      if (tabulations.loadingEvents) {
        return { isLoading: true };
      }

      _this.isLoading = false;

      return _extends({}, tabulations);
    })(this);

    $scope.$on('$destroy', function () {
      return $timeout.cancel(refreshPromise);
    });

    refresh();
  }

  _createClass(TabulationsController, [{
    key: 'addScoresheet',
    value: function addScoresheet($event, event) {
      this.eventPipeline.addScoresheet($event, event);
    }
  }, {
    key: 'openScoresheet',
    value: function openScoresheet(e, a) {
      this.eventPipeline.openScoresheet(e, a);
    }
  }, {
    key: '_moveToTabs',
    value: function _moveToTabs(event, $event) {
      var _this2 = this;

      if (event.is_in_qa && !event.is_in_tabs) {
        this._svc.$ngRedux.dispatch((0, _events4.sendEventToTabs)(this.feis.id, event.id, event.version_id)).then(function (response) {
          if (response && response.errors && response.errors.status === 417) {
            var _ref = response.errors.data && response.errors.data.errors[0],
                title = _ref.title,
                detail = _ref.detail;

            _this2._svc.fAlert($event, title, detail);
          }
        });
      } else {
        // automatically open the add scoresheet dialogue for an event when it is moved to tabs, if we don't already have enough score sheets
        if (!event.adjudicators || event.adjudicators && event.adjudicators.length == 0) {
          this._svc.$ngRedux.dispatch((0, _events4.getAdjudicatorsForEvent)(this.feis.id, event.id)).then(function (res) {
            event.adjudicators = res.payload;
            _this2._svc.$ngRedux.dispatch((0, _events4.sendEventToTabs)(_this2.feis.id, event.id, event.version_id)).then(function (response) {
              if (response && response.errors && response.errors.status === 417) {
                var _ref2 = response.errors.data && response.errors.data.errors[0],
                    title = _ref2.title,
                    detail = _ref2.detail;

                _this2._svc.fAlert($event, title, detail);
              } else {
                _this2.addScoresheet(null, event);
              }
            });
          });
        } else {
          var expected = this._expectedScoresheets(event);
          if (expected > event.adjudicators.length) {
            this.addScoresheet(null, event);
          }
          this._svc.$ngRedux.dispatch((0, _events4.sendEventToTabs)(this.feis.id, event.id, event.version_id)).then(function (response) {
            if (response && response.errors && response.errors.status === 417) {
              var _ref3 = response.errors.data && response.errors.data.errors[0],
                  title = _ref3.title,
                  detail = _ref3.detail;

              _this2._svc.fAlert($event, title, detail);
            }
          });
        }
      }
    }
  }, {
    key: 'getExpectedScoresheetsForEvent',
    value: function getExpectedScoresheetsForEvent(eventType) {
      return (0, _events3.getExpectedScoresheets)(eventType);
    }
  }, {
    key: 'toggleCheckin',
    value: function toggleCheckin(event) {
      if (event.is_in_tabs && !event.is_in_qa) return;
      this._moveToTabs(event);
    }
  }, {
    key: 'sendToQa',
    value: function sendToQa(event, $event) {
      var _this3 = this;

      // actually move the event to QA in the DB
      if (!event.adjudicators || event.adjudicators && event.adjudicators.length == 0) {
        this._svc.$ngRedux.dispatch((0, _events4.getAdjudicatorsForEvent)(this.feis.id, event.id)).then(function (res) {
          event.adjudicators = res.payload;
          _this3.eventPipeline.sendToQA(event, $event);
        });
      } else {
        this.eventPipeline.sendToQA(event, $event);
      }
    }
  }, {
    key: 'openScoresheetMenu',
    value: function openScoresheetMenu($event, event, openMenu) {
      var _this4 = this;

      if (!event.adjudicators || event.adjudicators && event.adjudicators.length == 0) {
        this._svc.$ngRedux.dispatch((0, _events4.getAdjudicatorsForEvent)(this.feis.id, event.id)).then(function (res) {
          if (res.payload.length > 0) {
            console.log('----opening menu-----------', _this4.tabsEvents.toJS());
            openMenu();
          } else {
            event.adjudicators = res.payload;
            _this4.addScoresheet($event, event);
          }
        });
      } else {
        event.adjudicators.length > 0 ? openMenu() : this.addScoresheet($event, event);
      }
    }
  }, {
    key: 'sendToResults',
    value: function sendToResults(event, $event) {
      var _this5 = this;

      this._svc.$ngRedux.dispatch((0, _events4.cachePlacements)(this.feis.id, event.id)).then(function () {
        return _this5._svc.$ngRedux.dispatch((0, _events4.sendEventToResults)(_this5.feis.id, event.id, event.version_id));
      }).then(function (response) {
        if (response && response.errors && response.errors.status === 417) {
          var _ref4 = response.errors.data && response.errors.data.errors[0],
              title = _ref4.title,
              detail = _ref4.detail;

          _this5._svc.fAlert($event, title, detail);
        } else {
          return Promise.resolve();
        }
      }).then(function () {
        return _this5._svc.$state.go('feiseanna.one.admin.tabulations', { feis: _this5.feis });
      });
    }
  }, {
    key: 'openReview',
    value: function openReview(e) {
      this._svc.$state.go('feiseanna.one.review', { source: 'tabulations', event: e.id });
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      if (event) {
        return (0, _ifeisIsomorphic.getDescription)(event);
      }
    }
  }, {
    key: '_expectedScoresheets',
    value: function _expectedScoresheets(event) {
      return event.type === 'C' ? 3 : 1;
    }
  }]);

  return TabulationsController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.tabulations', ['ui.router', 'ifeis.router-history', 'ifeis.routes.feiseanna.one.admin.tabulations.scoresheet', 'ifeis.routes.feiseanna.one.admin.tabulations.review', 'ifeis.adjudicators', 'ifeis.events', 'ifeis.eventPipeline']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.tabulations', {
    url: '/tabulations',
    template: require('./tpl.html'),
    controller: TabulationsController,
    controllerAs: 'ctrl',
    resolve: {
      hasNumberAssigned: function hasNumberAssigned(feis, $q) {
        if (feis.has_competitor_numbers_assigned) {
          return $q.resolve();
        }
        return $q.reject();
      }
    },
    ncyBreadcrumb: {
      label: 'Tabulations',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/tabulations/index.js
// module id = 579
// module chunks = 0